import { render, staticRenderFns } from "./dnd.vue?vue&type=template&id=589ef92a"
import script from "./dnd.vue?vue&type=script&lang=js"
export * from "./dnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports